function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,660.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M150 3340 l0 -3130 3140 0 3140 0 0 3130 0 3130 -3140 0 -3140 0 0 -3130z m1650 400 l0 -1870 1885 0 1885 0 0 -400 0 -400 -2280 0 -2280 0 0 2270 0 2270 395 0 395 0 0 -1870z m1634 1808 c3 -35 13 -521 23 -1080 l17 -1018 190 1 c105 0 575 8 1044 17 470 10 856 15 858 13 2 -2 4 -172 4 -378 l0 -373 -1455 0 -1455 0 0 1440 0 1440 384 0 384 0 6 -62z m1496 -283 l0 -345 320 0 320 0 0 -285 c0 -220 -3 -287 -12 -290 -19 -5 -1229 -27 -1235 -22 -2 3 -8 216 -13 474 -5 257 -11 546 -13 641 l-5 172 319 0 319 0 0 -345z"
}));

function SvgIconBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "662.000000pt",
    height: "660.000000pt",
    viewBox: "0 0 662.000000 660.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlack);
export default __webpack_public_path__ + "static/media/icon-black.534c04e8.svg";
export { ForwardRef as ReactComponent };